(function () {
  'use strict';

  function initHbb(section) {
    const modal = section.querySelector('[data-hbb-modal]');
    const form = section.querySelector('[data-hbb-form]');
    if (!modal || !form) return;

    // ---- Hero gallery (main image only, navigated via prev/next arrows —
    // the thumb strip was removed; swipe/scroll still works on mobile).
    // The scrolling element on mobile is now .hbb__slides-track (not
    // .hbb__main-image itself) — see the .liquid/.css comments next to it
    // for why (nav buttons used to scroll away with the content). ----
    const slides = Array.from(section.querySelectorAll('[data-hbb-slide]'));
    const scroller = section.querySelector('.hbb__slides-track');
    const dots = Array.from(section.querySelectorAll('[data-hbb-dot]'));
    let heroIndex = 0;

    function showSlide(i) {
      if (!slides.length) return;
      heroIndex = i;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      if (scroller && slides[i] && scroller.scrollWidth > scroller.clientWidth) {
        slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
    }

    section.querySelectorAll('[data-hbb-nav]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const total = slides.length;
        if (!total) return;
        const next = btn.dataset.hbbNav === 'next' ? (heroIndex + 1) % total : (heroIndex - 1 + total) % total;
        showSlide(next);
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        showSlide(parseInt(dot.dataset.hbbDot, 10) || 0);
      });
    });

    // ---- Native swipe/scroll sync (mobile) ----
    // The user can drag .hbb__slides-track directly, bypassing showSlide()
    // entirely. This listener figures out which slide is now nearest the
    // scrolled-to position (scrollLeft / clientWidth, rounded — each slide
    // is a full-width flex: 0 0 100% column, see .css) and updates
    // heroIndex + the is-active state on slides/dots to match, purely
    // visual (no scrollIntoView call here, which would fight the user's
    // own in-progress scroll and create a feedback loop). Lightly
    // debounced since 'scroll' fires continuously while dragging.
    if (scroller) {
      let scrollSyncTimer = null;
      scroller.addEventListener('scroll', () => {
        clearTimeout(scrollSyncTimer);
        scrollSyncTimer = setTimeout(() => {
          if (!scroller.clientWidth) return;
          const i = Math.round(scroller.scrollLeft / scroller.clientWidth);
          if (i === heroIndex || i < 0 || i >= slides.length) return;
          heroIndex = i;
          slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }, 100);
      });
    }

    // ---- Sticky/pinned gallery image: removed ----
    // Two different implementations (native CSS position:sticky, then a
    // full custom JS rewrite with a fixed/absolute state machine) were
    // built and tested here, but the client decided to abandon the sticky
    // behavior entirely after repeated real-browser testing kept surfacing
    // inconsistent results. No code for it remains — the gallery image now
    // scrolls in completely normal document flow, same as any other
    // element on the page.

    // ---- Inline picker open/close ----
    // Inline variant: there is no overlay/dialog to open — [data-hbb-open-modal]
    // instead scrolls smoothly to the always-visible picker below, offset for
    // the fixed header + .hsnav (same offset approach as the "read reviews"
    // script in the .liquid). closeModal is a no-op (still passed through to
    // handleAddToCart/pageshow below, which call it unconditionally) since the
    // picker must never be hidden.
    let lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      const header = document.querySelector('.hsnav') || document.querySelector('header');
      const offset = (header ? header.getBoundingClientRect().height : 0) + 8;
      const top = modal.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('lowen:harness_options_opened', {});
      }
    }

    function closeModal() {
      // No-op: the picker is always inline/visible, never hidden.
    }

    section.querySelectorAll('[data-hbb-open-modal]').forEach((btn) => {
      btn.addEventListener('click', openModal);
    });
    modal.querySelectorAll('[data-hbb-modal-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    // ---- Sticky bar: the only Add to Cart entry point (see .liquid comment
    // next to it) — always visible from first paint via CSS, on both desktop
    // and mobile, matching the reference page. No scroll-based show/hide.

    // ---- Sticky bar message ticker: same interaction as the reference
    // page's "Manufactured In The USA" banner — manual prev/next arrows plus
    // auto-rotation between slides. Entirely self-contained: doesn't touch
    // the price/CTA elements beside it.
    (function initTicker() {
      const ticker = section.querySelector('[data-hbb-ticker]');
      if (!ticker) return;
      const trackInner = ticker.querySelector('[data-hbb-ticker-track-inner]');
      const slides = Array.from(ticker.querySelectorAll('[data-hbb-ticker-slide]'));
      if (!trackInner || slides.length < 2) return; // nothing to rotate through

      const intervalSeconds = Number(ticker.dataset.hbbTickerInterval) || 5;
      let tickerIndex = slides.findIndex((s) => s.classList.contains('is-active'));
      if (tickerIndex < 0) tickerIndex = 0;
      let timer = null;

      // Slides a real translateX distance (not a crossfade) so the change
      // reads as visible motion, matching how the reference page's own
      // ticker scrolls between messages.
      function showTickerSlide(i) {
        tickerIndex = (i + slides.length) % slides.length;
        slides.forEach((s, n) => s.classList.toggle('is-active', n === tickerIndex));
        trackInner.style.transform = 'translateX(-' + tickerIndex * 100 + '%)';
      }

      function startAutoRotate() {
        stopAutoRotate();
        timer = setInterval(() => showTickerSlide(tickerIndex + 1), intervalSeconds * 1000);
      }
      function stopAutoRotate() {
        if (timer) clearInterval(timer);
      }

      const prevBtn = ticker.querySelector('[data-hbb-ticker-prev]');
      const nextBtn = ticker.querySelector('[data-hbb-ticker-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          showTickerSlide(tickerIndex - 1);
          startAutoRotate(); // manual nav resets the timer rather than fighting it
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          showTickerSlide(tickerIndex + 1);
          startAutoRotate();
        });
      }

      startAutoRotate();
    })();

    // ---- Variant matching (color + size -> real variant id/price/image) ----
    // Generalized below (createVariantGroup) to support 1-3 independent
    // "harness" groups added by the quantity tier selector — group 1 is
    // the original, always-present group; its own DOM/attributes are
    // untouched, only queried through a scoped container now (see
    // .liquid's data-hbb-variant-group="1" wrapper) so it never collides
    // with groups 2/3. All groups share this same variantEls lookup table
    // — there's only one real product, no need to duplicate it.
    const variantEls = Array.from(section.querySelectorAll('[data-hbb-variant-data] [data-variant-id]'));
    const variantInput = section.querySelector('[data-hbb-variant-input]');
    const submitBtn = section.querySelector('[data-hbb-submit]');
    const ctaLabelEl = submitBtn ? submitBtn.querySelector('[data-hbb-cta-label]') : null;
    const ctaLabelOriginalText = ctaLabelEl ? ctaLabelEl.textContent : null;
    const modalPriceEl = section.querySelector('[data-hbb-modal-price]');
    const modalComparePriceEl = section.querySelector('[data-hbb-modal-compare]');
    const modalTitleEl = section.querySelector('[data-hbb-modal-title]');
    const modalImageEl = section.querySelector('[data-hbb-modal-image]');
    const heroPriceEl = section.querySelector('[data-hbb-hero-price]');
    const heroComparePriceEl = section.querySelector('[data-hbb-hero-compare-price]');
    const stickyPriceEl = section.querySelector('[data-hbb-sticky-price]');
    const modalError = section.querySelector('[data-hbb-modal-error]');

    // ---- Upsell / cross-sell checkboxes: declared before updateVariant()
    // (below) is first invoked, since updateVariant() calls updateTotal(),
    // which reads upsellCheckboxes/totalEl — both must already be
    // initialized by then (they're `const`, so referencing them any
    // earlier throws a temporal-dead-zone ReferenceError that would
    // otherwise abort initHbb() partway through, silently skipping every
    // listener registered after that point, including the form's submit
    // handler that opens the cart drawer).
    const upsellCheckboxes = Array.from(section.querySelectorAll('[data-hbb-upsell-checkbox]'));
    const totalEl = section.querySelector('[data-hbb-total-price]');
    const compareEl = section.querySelector('[data-hbb-compare-price]');
    const shippingBar = section.querySelector('[data-hbb-shipping-bar]');
    const shippingText = section.querySelector('[data-hbb-shipping-text]');
    const shippingFill = section.querySelector('[data-hbb-shipping-fill]');
    const shippingThreshold = shippingBar ? parseFloat(shippingBar.dataset.threshold) || 0 : 0;

    // ---- Personalized Name Patch add-on: dynamic list of tag rows (one
    // per harness in the selected tier — same max the free-gift block
    // below reads as `groups.length`, read-only from here via
    // activeGroups()/tierCount(), neither of which is modified), additive
    // to the upsell checkboxes above (own elements, own listeners — none
    // of the upsellCheckboxes code below is touched). ----
    const patchContainer = section.querySelector('[data-hbb-patch]');
    const patchAddTrigger = section.querySelector('[data-hbb-patch-add-trigger]');
    const patchRowsContainer = section.querySelector('[data-hbb-patch-rows]');
    const patchAddMoreBtn = section.querySelector('[data-hbb-patch-add-more]');
    const patchRowTemplate = section.querySelector('[data-hbb-patch-row-template]');
    const patchVariantId = patchContainer ? patchContainer.dataset.patchVariantId : null;
    const patchPrice = patchContainer ? patchContainer.dataset.patchPrice : null;
    const patchPlaceholderBase = patchContainer ? (patchContainer.dataset.patchPlaceholder || 'Name') : 'Name';
    let patchRows = []; // { row, input, error }

    function patchMax() {
      return activeGroups().length;
    }

    function showPatchRowError(rowObj) {
      if (rowObj.input) rowObj.input.classList.add('has-error');
      if (rowObj.error) rowObj.error.classList.add('is-visible');
    }
    function hidePatchRowError(rowObj) {
      if (rowObj.input) rowObj.input.classList.remove('has-error');
      if (rowObj.error) rowObj.error.classList.remove('is-visible');
    }

    function updatePatchPlaceholders() {
      patchRows.forEach((r, i) => {
        r.input.placeholder = patchRows.length > 1 ? patchPlaceholderBase + ' ' + (i + 1) : patchPlaceholderBase;
      });
    }

    function updatePatchVisibility() {
      // Explicit inline style.display alongside the `hidden` attribute:
      // .hbb__patch-toggle-row (reused here for the trigger button) already
      // carries its own `display: flex` rule, same specificity as the
      // `[hidden]` UA default, so the attribute alone doesn't reliably hide
      // it — same class of theme-wide CSS-specificity gotcha as elsewhere
      // in this section (see base.css comments).
      const max = patchMax();
      if (patchAddTrigger) {
        const show = patchRows.length === 0;
        patchAddTrigger.hidden = !show;
        patchAddTrigger.style.display = show ? '' : 'none';
      }
      if (patchAddMoreBtn) {
        const show = patchRows.length > 0 && patchRows.length < max;
        patchAddMoreBtn.hidden = !show;
        patchAddMoreBtn.style.display = show ? '' : 'none';
      }
    }

    function addPatchRow(focusInput) {
      if (!patchRowTemplate || !patchRowsContainer) return;
      if (patchRows.length >= patchMax()) return;
      const node = patchRowTemplate.content.firstElementChild.cloneNode(true);
      const input = node.querySelector('[data-hbb-patch-name]');
      const error = node.querySelector('[data-hbb-patch-error]');
      const removeBtn = node.querySelector('[data-hbb-patch-remove]');
      const rowObj = { row: node, input: input, error: error };
      if (input) {
        input.addEventListener('input', () => {
          if (input.value.trim()) hidePatchRowError(rowObj);
          updateTotal();
        });
      }
      if (removeBtn) removeBtn.addEventListener('click', () => removePatchRow(rowObj));
      patchRowsContainer.appendChild(node);
      patchRows.push(rowObj);
      updatePatchPlaceholders();
      updatePatchVisibility();
      updateTotal();
      if (focusInput && input) input.focus();
    }

    function removePatchRow(rowObj) {
      const idx = patchRows.indexOf(rowObj);
      if (idx === -1) return;
      patchRows.splice(idx, 1);
      if (rowObj.row.parentNode) rowObj.row.parentNode.removeChild(rowObj.row);
      updatePatchPlaceholders();
      updatePatchVisibility();
      updateTotal();
    }

    function trimPatchRowsToMax() {
      const max = patchMax();
      while (patchRows.length > max) {
        removePatchRow(patchRows[patchRows.length - 1]);
      }
    }

    // ---- Quantity tier selector (1/2/3 Harness) ----
    // Purely additive: if no quantity_tier blocks are configured,
    // tierInputs is empty, tierCount() always returns 1, and every branch
    // below behaves exactly like the original single-group section.
    const tierInputs = Array.from(section.querySelectorAll('[data-hbb-tier-value]'));

    function selectedTierInput() {
      return tierInputs.find((el) => el.checked) || null;
    }
    function tierCount() {
      const checked = selectedTierInput();
      return checked ? parseInt(checked.value, 10) || 1 : 1;
    }

    // ---- Variant groups (one per harness slot) ----
    // Each group is scoped to its own [data-hbb-variant-group="N"]
    // container so its color/size radios (same data-hbb-color-value/
    // data-hbb-size-value attributes as always) never collide with any
    // other group. Group 1's container wraps the original, untouched
    // markup, so its resulting behavior (matching + the hero/modal
    // price/title/image side effects below) is unchanged from before this
    // feature existed — only *how* its inputs are queried (scoped to its
    // wrapper instead of the whole section) changed, to make room for
    // groups 2/3 without them colliding with group 1's own radios.
    function createVariantGroup(groupIndex) {
      const root = section.querySelector('[data-hbb-variant-group="' + groupIndex + '"]');
      if (!root) return null;

      const colorInputs = Array.from(root.querySelectorAll('[data-hbb-color-value]'));
      const sizeInputs = Array.from(root.querySelectorAll('[data-hbb-size-value]'));
      let currentVariant = null;

      function currentColor() {
        const checked = colorInputs.find((el) => el.checked);
        return checked ? checked.value : null;
      }
      function currentSize() {
        const checked = sizeInputs.find((el) => el.checked);
        return checked ? checked.value : null;
      }

      function update() {
        const color = currentColor();
        const size = currentSize();
        const match = variantEls.find((el) => {
          const matchesColor = color === null || el.dataset.color === color;
          const matchesSize = size === null || el.dataset.size === size;
          return matchesColor && matchesSize;
        });
        currentVariant = match || null;

        // Group 1 alone drives the shared hero/modal display elements near
        // the top of the panel (title/image/price row) — the exact same
        // side effects it always had, including leaving them at their last
        // valid value (not blanking them) when the current combination is
        // invalid — same as the original single-group code. Groups 2/3
        // don't touch these: there's only one such display and it isn't
        // meaningful for more than one harness at a time, so it stays tied
        // to Harness 1 specifically.
        if (groupIndex === 1 && match) {
          if (variantInput) variantInput.value = match.dataset.variantId;

          [modalPriceEl, heroPriceEl].forEach((el) => { if (el) el.textContent = match.dataset.price; });

          const hasCompare = match.dataset.compareAtPrice && match.dataset.compareAtPrice !== match.dataset.price;
          [modalComparePriceEl, heroComparePriceEl].forEach((el) => {
            if (!el) return;
            el.textContent = match.dataset.compareAtPrice || '';
            el.hidden = !hasCompare;
          });

          if (modalTitleEl) modalTitleEl.textContent = [size, color].filter(Boolean).join(' / ') || modalTitleEl.dataset.baseTitle;
          if (modalImageEl && match.dataset.image) modalImageEl.setAttribute('src', match.dataset.image);
        }

        return match;
      }

      colorInputs.forEach((el) => {
        el.addEventListener('change', onGroupChange);
        el.addEventListener('click', onGroupChange);
      });
      sizeInputs.forEach((el) => {
        el.addEventListener('change', onGroupChange);
        el.addEventListener('click', onGroupChange);
      });

      function onGroupChange() {
        update();
        refresh();
      }

      return {
        groupIndex: groupIndex,
        element: root,
        update: update,
        getVariant: function () { return currentVariant; },
      };
    }

    const variantGroups = [1, 2, 3].map(createVariantGroup).filter(Boolean);

    function activeGroups() {
      const count = tierCount();
      return variantGroups.filter((g) => g.groupIndex <= count);
    }

    // Moves the (single, real) variant-group nodes into the currently
    // selected tier card's slot — appendChild, never cloneNode, so the
    // exact same elements (with their already-bound event listeners) just
    // relocate in the DOM. Falls back to slot "1" when no tier is selected
    // (no quantity_tier blocks configured), matching tierCount()'s own
    // fallback.
    function moveVariantGroupsToSelectedSlot() {
      const tierInput = selectedTierInput();
      const index = tierInput ? tierInput.value : '1';
      const slot = section.querySelector('[data-hbb-tier-variants-slot="' + index + '"]');
      if (!slot) return;
      variantGroups.forEach((g) => slot.appendChild(g.element));
    }

    // Shows/hides the right number of variant groups for the selected
    // tier, and reveals the "Harness 1" heading only once a 2nd/3rd set
    // exists alongside it (hidden by default — see .liquid).
    function updateGroupVisibility() {
      moveVariantGroupsToSelectedSlot();
      const count = tierCount();
      variantGroups.forEach((g) => {
        g.element.hidden = g.groupIndex > count;
      });
      const group1Heading = section.querySelector('[data-hbb-variant-group="1"] [data-hbb-group-heading]');
      if (group1Heading) group1Heading.hidden = count <= 1;
    }

    tierInputs.forEach((el) => {
      el.addEventListener('change', () => {
        updateGroupVisibility();
        refresh();
      });
    });

    function parseMoney(str) {
      if (!str) return 0;
      const cleaned = str.replace(/[^0-9.,]/g, '').replace(',', '.');
      const value = parseFloat(cleaned);
      return isNaN(value) ? 0 : value;
    }

    function formatMoney(value) {
      // Mirrors the format of the surrounding {{ ... | money }} output by
      // reusing whatever currency symbol/format the main price already uses.
      const template = (modalPriceEl && modalPriceEl.textContent) || '$0.00';
      const symbolMatch = template.match(/^[^\d]*/);
      const symbol = symbolMatch ? symbolMatch[0] : '$';
      return symbol + value.toFixed(2);
    }

    function updateTotal() {
      // Real running total across every currently ACTIVE harness group
      // (1, 2, or 3 depending on the selected tier) + upsells + patch —
      // used by the free shipping bar below, unaffected by the manual
      // tier price text shown on the button (see displayPrice below).
      let groupsTotal = 0;
      activeGroups().forEach((g) => {
        const v = g.getVariant();
        if (v) groupsTotal += parseMoney(v.dataset.price);
      });
      let extraTotal = 0;
      upsellCheckboxes.forEach((cb) => {
        if (cb.checked) extraTotal += parseMoney(cb.dataset.upsellPrice);
      });
      const patchFilledCount = patchRows.filter((r) => r.input && r.input.value.trim()).length;
      if (patchFilledCount) extraTotal += patchFilledCount * parseMoney(patchPrice);
      const total = groupsTotal + extraTotal;

      // The CTA button/sticky bar show the selected quantity tier's own
      // manual price text (client spec — a placeholder, not a real-time
      // calculated total) PLUS any real upsell/patch extras on top, since
      // those are genuinely added at checkout and the button shouldn't
      // undersell what's actually being charged. Falls back to the real
      // computed total when no quantity_tier blocks exist at all — the
      // exact pre-existing behavior for a section with no tier selector.
      const tierInput = selectedTierInput();
      const displayPrice = tierInput
        ? formatMoney(parseMoney(tierInput.dataset.hbbTierPrice) + extraTotal)
        : formatMoney(total);
      if (totalEl) totalEl.textContent = displayPrice;
      if (stickyPriceEl) stickyPriceEl.textContent = displayPrice;

      // Compare-at (strikethrough) price next to the real price. Same
      // manual-text-vs-real-data split as displayPrice above: a selected
      // tier uses its own compare_price_text (already used in the tier
      // card), otherwise falls back to the real variant's compare_at_price
      // (data-compare-at-price, already on every variant span — see
      // .liquid). Hidden entirely rather than shown blank/stale when
      // neither is available.
      if (compareEl) {
        let compareText = '';
        if (tierInput) {
          compareText = tierInput.dataset.hbbTierComparePrice || '';
        } else {
          const v = activeGroups()[0] && activeGroups()[0].getVariant();
          if (v && parseMoney(v.dataset.compareAtPrice) > parseMoney(v.dataset.price)) {
            compareText = v.dataset.compareAtPrice;
          }
        }
        compareEl.textContent = compareText;
        compareEl.hidden = !compareText;
      }

      // Free shipping progress bar — reads the real `total` above, no
      // separate calculation of its own, and unaffected by the manual
      // tier price text.
      if (shippingBar && shippingThreshold > 0) {
        const percent = Math.min(100, (total / shippingThreshold) * 100);
        if (shippingFill) shippingFill.style.width = percent + '%';
        if (shippingText) {
          if (total >= shippingThreshold) {
            shippingText.textContent = shippingBar.dataset.reachedText;
          } else {
            const remaining = shippingThreshold - total;
            shippingText.textContent = shippingBar.dataset.belowText.replace('[amount]', formatMoney(remaining));
          }
        }
      }
    }

    upsellCheckboxes.forEach((cb) => cb.addEventListener('change', updateTotal));

    if (patchAddTrigger) patchAddTrigger.addEventListener('click', () => addPatchRow(true));
    if (patchAddMoreBtn) patchAddMoreBtn.addEventListener('click', () => addPatchRow(true));

    // Separate, additive listener on the same tierInputs elements (the
    // tierInputs.forEach block above is untouched) — trims excess tag rows
    // when the customer switches to a tier with fewer harness slots, without
    // blocking the tier change itself. Also re-syncs trigger/"add another"
    // visibility on every tier change (not just when trimPatchRowsToMax
    // actually removes a row), since raising the tier max alone doesn't
    // otherwise touch either button's visibility.
    tierInputs.forEach((el) => {
      el.addEventListener('change', () => {
        trimPatchRowsToMax();
        updatePatchVisibility();
      });
    });

    updatePatchVisibility();

    // ---- Combined validity + error message across every currently ACTIVE
    // group (1, 2, or 3 depending on the selected tier) — same wording/
    // behavior as before for a single group, with the harness number
    // appended only once there's more than one group to distinguish. ----
    function refresh() {
      const groups = activeGroups();
      const invalidGroup = groups.find((g) => {
        const v = g.getVariant();
        return !v || v.dataset.available !== 'true';
      });

      if (invalidGroup) {
        if (submitBtn) submitBtn.disabled = true;
        if (modalError) {
          modalError.textContent = groups.length > 1
            ? 'This combination is unavailable for Harness ' + invalidGroup.groupIndex + '.'
            : 'This combination is unavailable.';
          modalError.classList.add('is-visible');
        }
      } else {
        if (submitBtn) submitBtn.disabled = false;
        if (modalError) modalError.classList.remove('is-visible');
      }

      updateTotal();
    }

    updateGroupVisibility();
    variantGroups.forEach((g) => g.update());
    refresh();

    // ---- Re-sync on pageshow: fires on both a normal load and a
    // back/forward-navigation return, including cases where the browser
    // silently restores radio/checkbox checked state from history without
    // firing any change event — leaving currentVariant/variantInput stale
    // relative to what's visibly selected. Re-running the same three
    // idempotent setup calls above re-reads the DOM's actual current
    // checked state and resyncs everything from it, regardless of the
    // exact browser mechanism that caused the drift.
    window.addEventListener('pageshow', function () {
      // ---- Always close the options modal on return to this page: a
      // back/forward-navigation return can hand back a page with the modal
      // still open from before the shopper left for checkout. closeModal()
      // is safe to call even when already closed (just sets modal.hidden
      // back to true, a no-op). This only runs on return, never during the
      // /cart/add.js wait itself (that logic is untouched, elsewhere).
      closeModal();
      if (ctaLabelEl && ctaLabelOriginalText !== null) ctaLabelEl.textContent = ctaLabelOriginalText;

      updateGroupVisibility();
      variantGroups.forEach(function (g) { g.update(); });
      refresh();

      // ---- Open the cart-drawer on return from checkout (back button) ----
      // sessionStorage flag set right before navigating to /checkout, from
      // both known exit points: handleProceedToCheckout() below, and the
      // cart-drawer's own native "Checkout Now" form submit (see the submit
      // listener on #CartDrawer-Form in snippets/cart-drawer.liquid). Read
      // and consumed (removeItem) exactly once here, right at the top of
      // this handler, regardless of whether the resync below succeeds —
      // this guarantees a later, unrelated pageshow (e.g. a plain reload of
      // this same page) never re-opens the drawer just because a previous
      // resync happened to fail. Never opens the modal — that stays closed
      // via closeModal() above, untouched.
      var isReturningFromCheckout = false;
      try {
        if (sessionStorage.getItem('lowen_checkout_redirect')) {
          isReturningFromCheckout = true;
          sessionStorage.removeItem('lowen_checkout_redirect');
        }
      } catch (err) {
        // sessionStorage can throw in some privacy modes — never let that
        // block the rest of pageshow (same defensive posture as below).
      }

      // ---- Re-sync the header cart icon/drawer too, on the same trigger
      // and for the same reason: a pageshow can hand back a page whose
      // markup (including the cart icon's server-rendered count and the
      // drawer's server-rendered contents) was never regenerated for the
      // real, current cart state — observed concretely with the browser's
      // HTTP disk cache serving a stale copy of this page from before an
      // item was added (navigation.deliveryType === 'cache'), independent
      // of and in addition to the variant-matching drift handled above.
      // Plain GET /cart.json does NOT return rendered `sections` (verified
      // empirically — it's a read-only endpoint), so it can't feed
      // cart-drawer's renderContents() directly. A no-op POST to
      // /cart/update.js (empty `updates`, so nothing about the cart itself
      // changes) with `sections`/`sections_url` does return the same
      // `sections` shape /cart/add.js produces, which is what
      // renderContents() expects — confirmed empirically before writing
      // this. dontOpen stays true here too: this must never pop the drawer
      // open on its own. Entirely best-effort: any failure here is caught
      // and swallowed so it can never break the variant-matching resync
      // above, which must keep working regardless.
      try {
        const cart = document.querySelector('cart-drawer');
        if (cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function') {
          const sections = cart.getSectionsToRender().map(function (section) { return section.id; }).join(',');
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: {}, sections: sections, sections_url: window.location.pathname }),
          })
            .then(function (response) { return response.json(); })
            .then(function (data) {
              try {
                cart.renderContents(data, true);
                cart.classList.toggle('is-empty', data.item_count === 0);

                // Only reached after renderContents() above has swapped in
                // the real, current cart contents — so the shopper never
                // sees a stale/empty snapshot for an instant. If this resync
                // throws (caught below), the drawer is deliberately left
                // closed rather than opened with content that might already
                // be wrong (e.g. showing "empty" right after a real
                // purchase) — the flag is already consumed above either way,
                // so this is a one-time miss, not a dangling re-trigger.
                if (isReturningFromCheckout && typeof cart.open === 'function') cart.open();
              } catch (err) {
                console.error('Cart icon/drawer pageshow sync failed (non-blocking):', err);
              }
            })
            .catch(function (err) {
              console.error('Cart icon/drawer pageshow sync request failed (non-blocking):', err);
            });
        }
      } catch (err) {
        console.error('Cart icon/drawer pageshow sync setup failed (non-blocking):', err);
      }
    });

    // ---- Proceed to Checkout: adds items via the same single /cart/add.js
    // call as before (main variant + Custom Name Tag if toggled + any
    // checked upsells, same validation), then redirects straight to
    // /checkout — see handleProceedToCheckout() below. This button no
    // longer opens the cart-drawer at all; handleAddToCart() and the
    // cart-drawer integration below are left fully intact and unused by
    // this button, in case anything else on this section ever needs them
    // again (e.g. a future "Add to Cart" button elsewhere in this panel).
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      // One line item per currently ACTIVE harness group (1, 2, or 3
      // depending on the selected quantity tier), each quantity 1 at its
      // own real variant price — the manual tier price text is a display
      // label only (see updateTotal above), never sent to the cart.
      const groups = activeGroups();
      const invalidGroup = groups.find((g) => {
        const v = g.getVariant();
        return !v || v.dataset.available !== 'true';
      });
      if (invalidGroup) return; // submitBtn is already disabled by refresh(); safety no-op guard

      // Item order in the /cart/add.js payload is intentional (cart-drawer
      // display order follows insertion order): harness(es), name tag,
      // leash, then whatever else (upsell), with Guide Bundle + Guarantee
      // always pinned as the last two entries.
      const items = groups.map((g) => ({ id: g.getVariant().dataset.variantId, quantity: 1 }));

      let firstInvalidPatchRow = null;
      patchRows.forEach((r) => {
        if (r.input && r.input.value.trim()) {
          hidePatchRowError(r);
        } else {
          showPatchRowError(r);
          if (!firstInvalidPatchRow) firstInvalidPatchRow = r;
        }
      });
      if (firstInvalidPatchRow) {
        if (firstInvalidPatchRow.input) firstInvalidPatchRow.input.focus();
        return;
      }
      patchRows.forEach((r) => {
        items.push({
          id: patchVariantId,
          quantity: 1,
          properties: { 'Dog Name': r.input.value.trim() },
        });
      });

      const giftVariantEl = form.querySelector('[data-hbb-gift-variant-id]');
      if (giftVariantEl) items.push({ id: giftVariantEl.dataset.hbbGiftVariantId, quantity: groups.length });

      upsellCheckboxes.forEach((cb) => {
        if (cb.checked && cb.dataset.upsellVariantId) {
          items.push({ id: cb.dataset.upsellVariantId, quantity: 1 });
        }
      });

      const giftVariantEl3 = form.querySelector('[data-hbb-gift-variant-id-3]');
      if (giftVariantEl3) items.push({ id: giftVariantEl3.getAttribute('data-hbb-gift-variant-id-3'), quantity: 1 });

      const giftVariantEl2 = form.querySelector('[data-hbb-gift-variant-id-2]');
      if (giftVariantEl2) items.push({ id: giftVariantEl2.getAttribute('data-hbb-gift-variant-id-2'), quantity: 1 });

      // This store's /cart/add.js stores multi-item payloads in the
      // reverse of the submitted array order (confirmed empirically,
      // independent of item count/combination) — reverse here so the
      // resulting cart/checkout order matches the array order built above.
      items.reverse();

      // Modal stays open during the /cart/add.js round-trip (see
      // handleProceedToCheckout below) instead of closing immediately —
      // avoids a visible flash of the bare product page while the network
      // request is in flight. closeModal is passed through since
      // handleProceedToCheckout is defined outside this closure and has no
      // access to it otherwise; it's only actually invoked on the error
      // fallback path, to preserve the original close-before-reload behavior.
      handleAddToCart(form, submitBtn, items, closeModal);
    });
  }

  // ---------------------------------------------------------------------
  // handleAddToCart + forceResetCartDrawer are copied verbatim from
  // assets/variant-picker-simple.js — that add-to-cart + cart-drawer
  // integration is already solved and stable (see CLAUDE.md section 4).
  // Neither is called by this section's own submit handler above anymore
  // (see handleProceedToCheckout below), but both are left in place as-is,
  // untouched — the cart-drawer component itself isn't removed from the
  // codebase, only this button's own behavior changed.
  // ---------------------------------------------------------------------

  // Reuses the theme's existing spinner markup/classes (already defined
  // globally in base.css — see e.g. the checkout button in
  // snippets/cart-drawer.liquid) so no other file needs to change for
  // this loading state.
  function createCartDrawerLoadingOverlay() {
    const overlay = document.createElement('div');
    overlay.setAttribute('data-hbb-cart-loading-overlay', '');
    overlay.style.cssText =
      'position:absolute;inset:0;z-index:5;display:flex;align-items:center;justify-content:center;' +
      'background:#ffffff;';
    overlay.innerHTML =
      '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" ' +
      'xmlns="http://www.w3.org/2000/svg" style="width:2rem;height:2rem;">' +
      '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
    return overlay;
  }

  async function handleAddToCart(form, submitBtn, items, closeModal) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const originalText = submitBtn ? submitBtn.innerHTML : null;
    const canOpenDrawerOptimistically =
      cart && typeof cart.open === 'function' && typeof cart.renderContents === 'function';

    if (submitBtn) submitBtn.disabled = true;

    // Open the real cart-drawer right away instead of waiting for the
    // /cart/add.js round-trip (measured ~500-700ms network+server time,
    // not reducible from here — see the timing notes in this session's
    // summary) — same close-Choose-Options -> open-cart-drawer sequence
    // as before, just no longer gated on the response. A spinner overlay
    // covers whatever stale content (or empty state) is already in the
    // drawer until renderContents() swaps in the real thing.
    let loadingOverlay = null;
    let panel = null;
    if (canOpenDrawerOptimistically) {
      if (closeModal) closeModal();
      cart.open();
      panel = cart.querySelector('.drawer__inner') || cart;
      // .drawer__inner has no position of its own in base.css — give the
      // overlay a positioning context scoped to the panel itself, instead
      // of it falling back to <cart-drawer> (position:fixed, full viewport).
      if (!panel.style.position) panel.style.position = 'relative';
      loadingOverlay = createCartDrawerLoadingOverlay();
      panel.appendChild(loadingOverlay);
    }

    // Client-side timeout: on a slow/hanging connection the browser's own
    // fetch failure can take much longer than this to surface, which would
    // otherwise leave the drawer's loading spinner up (looking like it's
    // working) for that whole time before the abrupt fallback reload. 6s
    // sits in the middle of the requested 5-8s range — several times the
    // ~500-700ms this endpoint normally takes (see timing notes), so a
    // genuinely slow-but-valid response is never mistaken for a failure,
    // while a truly stuck request still gets cut off at a bounded time.
    const ADD_TO_CART_TIMEOUT_MS = 6000;
    const abortController = new AbortController();
    const timeoutId = setTimeout(() => abortController.abort(), ADD_TO_CART_TIMEOUT_MS);

    let data;
    try {
      const body = { items };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(
        window.Shopify ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
          signal: abortController.signal,
        }
      );

      data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }
    } catch (err) {
      console.error(err.name === 'AbortError' ? 'Add to cart timed out after ' + ADD_TO_CART_TIMEOUT_MS + 'ms' : err);
      if (loadingOverlay) loadingOverlay.remove();
      if (submitBtn) {
        submitBtn.disabled = false;
        if (originalText !== null) submitBtn.innerHTML = originalText;
      }
      if (canOpenDrawerOptimistically) forceResetCartDrawer(cart);
      form.submit();
      return;
    } finally {
      clearTimeout(timeoutId);
    }

    const cartUrl = (window.Shopify ? window.Shopify.routes.root : '/') + 'cart';

    if (!canOpenDrawerOptimistically) {
      window.location.href = cartUrl;
      return;
    }

    try {
      cart.renderContents(data);
      cart.classList.remove('is-empty');
    } catch (err) {
      console.error('Add to cart succeeded, but refreshing the cart drawer failed:', err);
      if (loadingOverlay) loadingOverlay.remove();
      forceResetCartDrawer(cart);
      window.location.href = cartUrl;
      return;
    }

    // renderContents() replaces #CartDrawer-CartItems and friends via
    // innerHTML, but the loading overlay was appended directly to
    // .drawer__inner (outside that swapped region), so it survives the
    // render and needs an explicit removal here.
    if (loadingOverlay) loadingOverlay.remove();
    if (submitBtn) submitBtn.disabled = false;
  }

  // Same single /cart/add.js call and error handling as handleAddToCart
  // above, but on success it redirects straight to /checkout instead of
  // opening/rendering the cart-drawer — the cart-drawer code is simply
  // never invoked from this path. On failure, same fallback as
  // handleAddToCart: re-enable the button and let the native form submit.
  async function handleProceedToCheckout(form, submitBtn, items, closeModal) {
    const originalText = submitBtn ? submitBtn.innerHTML : null;
    const ctaLabel = submitBtn ? submitBtn.querySelector('[data-hbb-cta-label]') : null;

    if (submitBtn) submitBtn.disabled = true;
    if (ctaLabel) ctaLabel.textContent = 'Adding to Cart...';

    let data;
    try {
      const response = await fetch(
        window.Shopify ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        }
      );

      data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Add to cart failed');
      }
    } catch (err) {
      console.error(err);
      if (submitBtn) {
        submitBtn.disabled = false;
        if (originalText !== null) submitBtn.innerHTML = originalText;
      }
      if (closeModal) closeModal();
      form.submit();
      return;
    }

    // Flag consumed by the pageshow listener above, to open the cart-drawer
    // (never the modal) if the shopper hits back from checkout to land here.
    try {
      sessionStorage.setItem('lowen_checkout_redirect', '1');
    } catch (err) {
      // non-blocking — see the matching try/catch in the pageshow listener.
    }
    window.location.href = (window.Shopify ? window.Shopify.routes.root : '/') + 'checkout';
  }

  function forceResetCartDrawer(cart) {
    try {
      if (typeof cart.close === 'function') cart.close();
    } catch (err) {
      console.error('forceResetCartDrawer: cart.close() also failed:', err);
    }
    try {
      cart.classList.remove('active', 'animate');
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
      const overlay = cart.querySelector('.cart-drawer__overlay, .cart-notification__overlay');
      if (overlay) overlay.style.pointerEvents = 'none';
    } catch (err) {
      console.error('forceResetCartDrawer: manual cleanup also failed:', err);
    }
  }

  document.querySelectorAll('.hbb').forEach(initHbb);
})();
